import React from "react";

import MainRouter from "./Router";

const App: React.FC = () => <MainRouter />;

export default App;
